export enum Locale {
  BG = 'bg',
  EN = 'en'
}
